import axiosClient from './axiosClient';

const SELECTED_MENU_STORAGE_KEY = 'selected_menu_id';
const SELECTED_MENU_ESTABLISHMENT_STORAGE_KEY =
  'selected_menu_establishment_id';

const clearSelectedMenu = () => {
  localStorage.removeItem(SELECTED_MENU_STORAGE_KEY);
  localStorage.removeItem(SELECTED_MENU_ESTABLISHMENT_STORAGE_KEY);
};

const getSelectedMenuId = () => {
  const menuId = localStorage.getItem(SELECTED_MENU_STORAGE_KEY) || '';

  if (!menuId || !/^\d+$/.test(String(menuId))) {
    clearSelectedMenu();
    return '';
  }

  return menuId;
};

const hasMenuValidationError = (error) => {
  const errors = error?.response?.data?.errors || {};
  const message = String(error?.response?.data?.message || '').toLowerCase();

  return Boolean(
    errors.menu_id ||
      message.includes('selected menu') ||
      message.includes('menu id'),
  );
};

export const analyticsApi = {
  getMenuAnalytics(establishmentId, params = {}) {
    const explicitMenuId = Object.prototype.hasOwnProperty.call(
      params,
      'menu_id',
    );

    const menuId = explicitMenuId ? params.menu_id : getSelectedMenuId();
    const cleanMenuId = /^\d+$/.test(String(menuId || '')) ? menuId : '';

    return axiosClient
      .get(`/establishments/${establishmentId}/analytics`, {
        params: {
          ...params,
          ...(cleanMenuId
            ? {
                menu_id: cleanMenuId,
              }
            : {}),
        },
      })
      .catch((error) => {
        if (hasMenuValidationError(error)) {
          clearSelectedMenu();
        }

        return Promise.reject(error);
      });
  },
};

export default analyticsApi;